import { Box, Card, Modal } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../styles/Theme";
import { ReactComponent as IconFilter } from "../../../assets/Icon-Filter.svg";
import React, { useState } from "react";
import { VideoFilterModal } from "./VideoFilterModal";
import { generateGtmEvent } from "../../../Helpers";
import { SearchBar } from "../utils/SearchBar";

const useStyle = makeStyles((theme) => ({
  filterButton: {
    marginLeft: "auto",
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    width: "93px",
    height: "40px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "93px",
      height: "40px",
      color: theme.palette.text.primary,
      transition: "all 0.5 ease-in-out",
      boxShadow: "none",
    },
  },
  filterButtonActive: {
    marginLeft: "auto",
    backgroundColor: "#F2F2F2",
    width: "93px",
    height: "40px",
    color: theme.palette.text.primary,
    transform: "none",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "93px",
      height: "40px",
      color: theme.palette.text.primary,
      transform: "none",
    },
  },
  selectedFilterButton: {
    color: theme.palette.text.primary,
    borderRadius: "15px",
    "&:hover": {
      border: `2px solid ${v2theme.palette.primary.main}`,
      transform: "none",
    },
  },
  filterButtonIcon: {
    width: "16px",
    height: "16px",
  },
  searchIcon: {
    width: "16px",
    height: "16px",
    fontWeight: "bold",
  },
  filterModal: {
    position: "absolute",
    width: "900px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

interface SearchAndFilterProps {
  searchText: string;
  onSubmit: (searchQuery: string) => void;
  availableFilters: { id: string; name: string }[];
  activeFilters: string[];
  onFilterSubmit: (filterString: string) => void;
  hideFilterButton?: boolean;

  onInputChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

export const SearchBox = (props: SearchAndFilterProps) => {
  const classes = useStyle();
  const {
    searchText,
    onSubmit,
    availableFilters,
    activeFilters,
    onFilterSubmit,
    hideFilterButton,
    onInputChange,
  } = props;

  const [openFilter, setFilterOpen] = useState(false);
  const handleOpen = () => setFilterOpen(true);
  const handleClose = () => setFilterOpen(false);

  const HandleDataLayer = (text: string) => {
    generateGtmEvent({
      event: "link",
      action: "click",
      name: "onclick",
      type: "internal link",
      region: "main content",
      section: "explore",
      text: text,
    });
  };

  return (
    <>
      <Box sx={{ display: "flex", gap: "16px", marginLeft: "10px" }}>
        <SearchBar
          hideSearchButton
          searchText={searchText}
          onSubmit={onSubmit}
          onInputChange={onInputChange}
          HandleDataLayer={HandleDataLayer}
          placeholder={"Search all videos here..."}
        />
        {!hideFilterButton && (
          <Button
            onClick={handleOpen}
            size="medium"
            className={
              activeFilters.length > 0 ? classes.filterButtonActive : classes.filterButton
            }
            variant="contained"
            endIcon={
              activeFilters.length > 0 ? (
                <Box
                  sx={{ borderRadius: "50%", backgroundColor: "#000000" }}
                  className={classes.filterButtonIcon}>
                  <Typography
                    sx={{
                      color: "#ffffff",
                      fontSize: "0.6em",
                      fontWeight: "600",
                    }}>
                    {activeFilters.length}
                  </Typography>
                </Box>
              ) : (
                <IconFilter className={classes.filterButtonIcon} />
              )
            }>
            Filter
          </Button>
        )}
      </Box>
      <Modal open={openFilter} onClose={handleClose} aria-labelledby="filter-modal-title">
        <Card className={classes.filterModal}>
          <VideoFilterModal
            close={handleClose}
            filters={activeFilters}
            availableFilters={availableFilters}
            onFilterSubmit={onFilterSubmit}
          />
        </Card>
      </Modal>
    </>
  );
};
